import React from "react";
import { candidateAPI } from "../../api/candidate";
import { DeleteMeContent } from "../profile/Privacy/DeleteMeContent";
import { useLatestQuery } from "../../api/useLatestQuery";
import { useWhoAmI } from "../../user/useWhoAmI";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { CvpButton } from "../../generic-components/buttons/CvpButton";
import { CvpDialog } from "./CvpDialog";

interface DeleteMeDialogProps {
  onDismiss: () => void;
}

export const DeleteMeDialog = (props: DeleteMeDialogProps) => {
  const { onDismiss } = props;

  const { data: wasDeleteRequested, isFetched: isDeleteRequestedFetched } =
    useLatestQuery(["candidateAPI.checkWasDeleteRequested"], () =>
      candidateAPI.checkWasDeleteRequested({})
    );

  const L = useLocStore(LocContext.GENERAL);

  const { whoAmI } = useWhoAmI();
  const company = whoAmI.details.concernName;

  if (!isDeleteRequestedFetched) {
    return null;
  }

  return (
    <CvpDialog
      visible
      onHide={() => {
        onDismiss();
      }}
      closable={false}
    >
      <DeleteMeContent
        company={company}
        wasDeleteRequested={wasDeleteRequested}
        contentText={
          <>
            <p>
              {L.id("72c12b5da59a").loc(
                `Du har avvist "Generell samtykkeerklæring for behandling av personopplysninger". For å bruke CV-Portalen må du godta samtykkeerklæringen. Hvis du ikke ønsker å godta, må du be om å bli slettet.`
              )}
            </p>

            <p>
              {L.id("88715569533a").split(
                "Dersom du ønsker at din profil slettes kan du trykke på knappen under. {0} vil da bli informert og vil gjennomføre slettingen av din profil og personopplysninger så snart som mulig.",
                [company]
              )}
            </p>
          </>
        }
        cancelButton={
          <CvpButton
            label={L.id("4eea11ae3609").loc("Avbryt")}
            icon="pi pi-times"
            severity="secondary"
            onClick={() => {
              onDismiss();
            }}
          />
        }
        closeButton={
          <CvpButton
            label={L.id("7c9b9d9bb95c").loc("Lukk")}
            icon="pi pi-times"
            severity="secondary"
            onClick={() => {
              onDismiss();
            }}
          />
        }
      />
    </CvpDialog>
  );
};
